import { type FC } from 'react';
import { type IGrantedLocationView } from '@shared/services';
import { Radio } from '@selfinspectionorg/ui-kit';
import styles from './LoginLocation.module.scss';
import { formatGrantedLocationAddress } from '@/shared/utils';

interface Props {
  location: IGrantedLocationView;
  accountId: number;
  isSelected: boolean;
  onChange: () => void;
}

export const LoginLocation: FC<Props> = ({ location, accountId, isSelected, onChange }) => {
  const radioId = `LoginLocationRadio${accountId}-${location.id}`;

  return (
    <label className={styles.locationItem} htmlFor={radioId}>
      <div className={styles.locationText}>
        <div className={styles.name}>{location.name}</div>
        <div className={styles.address}>{formatGrantedLocationAddress(location)}</div>
      </div>
      <Radio id={radioId} name="login-account-selection" checked={isSelected} onChange={onChange} size="small" />
    </label>
  );
};
